import type { ReactNode } from 'react';

const tEmBlockValue = {
  em: (chunks: ReactNode) => (
    <em className="block font-serif italic">{chunks}</em>
  ),
};

export default tEmBlockValue;
